import Axios from "axios";

export class ComercialService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/comercial/lista?${queryParams}`).then(res => res.data);
    }

    newComercial(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/comercial/nuevo`, data).then(res => res.data);
    }

    editarComercial(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/comercial/editar`, data).then(res => res.data);
    }

    deleteComercial(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/comercial/eliminar/${id}`).then(res => res.data);
    }
}